import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { TestingRootPage } from 'pages/testing/testing-root';

@NgModule({
    declarations: [TestingRootPage],
    imports: [PagesModule, ComponentsModule]
})
export class TestingRootPageModule {}
